import { apiRequest } from './http';

export interface Plan {
    id: number;
    name: string;
    price: string;
    is_active: boolean;
    description: string | null;
}

export interface PlansResponse {
    success?: boolean;
    message?: string;
    data?: Plan[];
}

export function getPlans(): Promise<PlansResponse> {
    return apiRequest<PlansResponse>({
        endpoint: '/plans',
        method: 'GET',
    });
}
